import { createStore } from 'vuex'

import projectData from './ProjectData'
import settings from './Settings'
import users from './Users'
import mainChat from './MainChats'
import brandSettingTab from './brandSettings'
import ToursData from './Tours';
import ChangeRequest from './ChangeRequest';
import digitalOffice from './DigitalOffice';

const socketInstanceWatcher = (store) => {
    let previousSocketInstance = null;

    store.subscribe((mutation, state) => {
        const newSocketInstance = state.settings.socketInstance;
        if (Object.keys(newSocketInstance).length && newSocketInstance !== previousSocketInstance) {
            previousSocketInstance = newSocketInstance;
            if (Object.keys(state.projectData.getTaskSnapShotPayload).length) {
                store.dispatch('projectData/getTasksFromMongoDB', { ...state.projectData.getTaskSnapShotPayload, from: 'storeWatch' });
            }
            if (state.projectData.taskDetailPayloadId.taskId) {
                store.dispatch('projectData/getTaskDetailSnapShot', { ...state.projectData.taskDetailPayloadId, from: 'storeWatch' });
            }
            // if (Object.keys(state.mainChat.chatPaylaod).length) {
            //   store.dispatch('mainChat/setChats', { ...state.mainChat.chatPaylaod, from: 'storeWatch' });
            // }
            // if (Object.keys(state.mainChat.groupChatPayload).length) {
            //   store.dispatch('mainChat/setGroupChats', { ...state.mainChat.groupChatPayload, from: 'storeWatch' });
            // }
            // ============ UNIFIED CONVERSATIONS (PRIMARY) ============
            const conversationPayload = state.mainChat.conversations?.payload;
            if (conversationPayload && Object.keys(conversationPayload).length) {
                store.dispatch('mainChat/setConversations', {
                    ...conversationPayload,
                    from: 'storeWatch'
                });
            }

            // if (!conversationPayload || !Object.keys(conversationPayload).length) {
            //     if (Object.keys(state.mainChat.chatPaylaod || {}).length) {
            //         store.dispatch('mainChat/setChats', {
            //             ...state.mainChat.chatPaylaod,
            //             from: 'storeWatch'
            //         });
            //     }

            //     if (Object.keys(state.mainChat.groupChatPayload || {}).length) {
            //         store.dispatch('mainChat/setGroupChats', {
            //             ...state.mainChat.groupChatPayload,
            //             from: 'storeWatch'
            //         });
            //     }
            // }
        }
        else {
            previousSocketInstance = newSocketInstance
        }
    });
};

export default createStore({
    modules: {
        projectData,
        settings,
        users,
        mainChat,
        brandSettingTab,
        ToursData,
        ChangeRequest,
        digitalOffice,
    },
    plugins: [socketInstanceWatcher]
})
